(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["timer-sm"] && !Shopify.designMode) return;
  try {
    const offerButtonSelector = [
    '#main button',
    '#main input[type="submit"]',
    '#main input[type="button"]',
    '#main [role="button"]',
    '#main a.button',
    '#main a.button-secondary',
    '#main a.custom-button',
    '#main .shopify-payment-button',
    '#main .accelerated-checkouts',
    '.cart-container button',
    '.cart-container a.button',
    '.cart-container [role="button"]',
  ].join(',');

  window.beastDisableOfferButtons = () => {
    document.documentElement.dataset.offerExpired = 'true';
    document.querySelectorAll(offerButtonSelector).forEach((element) => {
      element.setAttribute('aria-disabled', 'true');
      if ('disabled' in element) element.disabled = true;
    });
  };

  window.beastEnableOfferButtons = () => {
    delete document.documentElement.dataset.offerExpired;
    document.querySelectorAll(offerButtonSelector).forEach((element) => {
      if (element.getAttribute('aria-disabled') !== 'true') return;
      element.removeAttribute('aria-disabled');
      if ('disabled' in element) element.disabled = false;
    });
  };

  document.addEventListener('click', (event) => {
    if (document.documentElement.dataset.offerExpired !== 'true') return;
    const target = event.target instanceof Element ? event.target.closest(offerButtonSelector) : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', (event) => {
    if (document.documentElement.dataset.offerExpired !== 'true') return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('#main, .cart-container')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  const lockExpiredOffer = () => {
    if (document.documentElement.dataset.offerExpired !== 'true' && !document.querySelector('[data-offer-expired]')) return;
    window.beastDisableOfferButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockExpiredOffer);
  } else {
    lockExpiredOffer();
  }
  } catch(e) { console.error(e); }
})();

})();
